import {Component, HostListener} from '@angular/core';
import {LaunchDialogService} from '@spartacus/storefront';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Component({
  selector: 'dcp-write-review-modal',
  templateUrl: './write-review-dialog.component.html',
  styleUrls: ['./write-review-dialog.component.scss']
})
export class WriteReviewDialogComponent {

  constructor(
    public launchDialogService: LaunchDialogService
  ) {
  }

  @HostListener('document:keydown.escape')
  @HostListener('click', ['$event'])
  handleClickOrEsc(): void {
    this.launchDialogService.closeDialog('Cross click');
  }

  public get link$(): Observable<string> {
    return this.launchDialogService.data$.pipe(map((data) => data.link));
  }

  public get headlineText$(): Observable<string> {
    return this.launchDialogService.data$.pipe(map((data) => data.headlineText));
  }
}
